<div>
  <span>Registramed</span>
  <span class="text-body-secondary"> · </span>
  <span class="text-body-secondary">{{ year }} Innovax</span>
</div>
<div class="ms-auto text-body-secondary small">
  Panel de administración
</div>
